var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBdoLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bdoLogo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 108.9",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n                .locator {\r\n                  fill: #ed1a3b;\r\n                }\r\n\r\n                .typeface {\r\n                  fill: #21409a;\r\n                }\r\n              ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "typeGroup"
  }, /*#__PURE__*/React.createElement("path", {
    className: "typeface",
    d: "M53.8,45.1h9.9c16.2,0,24.5,3.5,24.5,13c0,8.4-6.6,12-17,12c-2.7,0-12.1,0-15.8,0L37.2,82.8v0l33.7,0                                                 c20.2,0,33.8-7.3,33.8-24.1c0-14.7-12-20.4-22.8-20.4c7.4,0,16.2-6.7,16.2-17.9C98.2,9,87.9,0.9,76.1,0.9l-34.4,0h-7.5l3,6.7v69.3                                                 l16.5-11.6V45.1z M53.8,13.6h17.3c4.8,0,10.8,1.1,10.8,9.2c0,8.1-8.6,11.4-15,11.4H53.8V13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "typeface",
    d: "M132,13.6h11.3c4.6,0,28.3,1.2,28.3,28.3c0,30.9-28.3,28.3-28.3,28.3l-9.7,0l-18.1,12.7v0h32.4                                                 c20.2,0,40.9-12.4,40.9-40.9c0-25.3-18.1-40.9-40.9-40.9h-35.5l3,6.7v69.3L132,65.3V13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "typeface",
    d: "M196.5,41.8c0,32.7,26.4,41.8,43.5,41.8c17.1,0,43.5-9.2,43.5-41.8C283.5,9.2,257.1,0,240,0                                                 C222.9,0,196.5,9.2,196.5,41.8z M213.7,41.8c0-23.2,16-29.7,26.3-29.7c10.3,0,26.3,6.5,26.3,29.7c0,23.2-16,29.7-26.3,29.7                                                 C229.6,71.5,213.7,65,213.7,41.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "locatorGroup"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "locator",
    points: "0,0.9 0,103 16.1,91.7 16.1,0.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "locator",
    points: "19.2,95.4 0,108.9 282.6,108.9 282.6,95.4"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBdoLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bdoLogo.ef17becf325f90da45b0c177e60279fa.svg";